<template>
    <div class="space-y-2xl">
        <div class="grid grid-cols-2 gap-sm md:grid-cols-3">
            <sb-article-recommended v-for="(article, index) in articles"
                :key="index"
                :blok="article"
                :article="article.uuid" />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ISbStoryData } from 'storyblok-js-client';

const properties = defineProps<{
    feed: string[]
    story: ISbStoryData
}>();

const { data: articlesResponse } = useStoryblokArticles({
    categories: properties.feed,
    /* eslint-disable @typescript-eslint/naming-convention */
    filters: {
        _uid: {
            // eslint-disable-next-line no-underscore-dangle
            not_like: properties.story.content._uid,
        },
    },
    /* eslint-enable @typescript-eslint/naming-convention */
    perPage: 3,
});

const articles = computed(() => articlesResponse.value?.stories);

// const articles = computed(() => data.value?.data.stories || []);
</script>
